import { createContext } from 'react';
import {BaseScopeReference} from "@/src/components/scope/ScopeModel";

export interface ProjectContextType {

    project_id: string | null;
    isLoading: boolean;
    // this determines whether bidder or developer on the whole project
    // per project -> gets refreshed when navigating to new project
    role: string;
    // list of scopes user has access to
    // used for dropdowns and selection and such
    scopes: BaseScopeReference[];


    // permissions: any;
    // setData: (data: any) => void;
    // getCompanyId: () => string;
}


export const ProjectContext = createContext<ProjectContextType | null>(null);